import React, {useState, useMemo, useEffect} from 'react'
import Link from '@material-ui/core/Link'
import CircularProgress from '@material-ui/core/CircularProgress'
import Icon from '@material-ui/core/Icon';

import Api, { handleError } from 'utils/Api'
import useFlash from 'modules/useFlash'
import {WrapForm, InfoPaper} from 'components/molecules/Wrap'
import InfoTable from 'components/molecules/InfoTable'
import InfoMain from '../parts/Information'

import useUpdater from 'modules/useUpdater'

import {TextEditor, ImageViewer} from 'components/organisms/MainAssetEditor'

export default (props) => {
  const version_fingerprint = props.match.params.fingerprint
  const id = props.match.params.id
  const {handleApiError} = useFlash()
  const [loading, setLoading] = useState(true)
  const [asset, setAsset] = useState()
  const [lastUpdatedAt, update] = useUpdater()

  useEffect(()=>{
    setLoading(true)

    const subject = Api.fetchAuth(`/main/versions/${version_fingerprint}/assets/${id}`).then(r=>r.json())
    Promise.all([subject]).then(responses=>{
      setAsset(responses[0].data)
      setLoading(false)
    }).catch(error=>{
      // setLoading(false)
      handleApiError(error)
    })
  }, [lastUpdatedAt])

  const onSave = () => {
    update()
  }

  if (loading) return (<CircularProgress />)

  const {version} = asset
  
  return (
    <WrapForm>
      <InfoMain version={version} />
      <InfoTable title="Main Asset" 
        rows={[
          {
            title: "path", 
            content: asset.publish_path, 
            subcontent: asset.publish_url ?
              (<Link href={asset.publish_url} target="_blank">{asset.publish_url}</Link>) :
              null
          },
          {
            title: "content type", 
            content: asset.content_type, 
            subcontent: null,
          },
          {
            title: "preview", 
            content: (
              (<Link href={asset.preview_url} target="_blank"><Icon>open_in_new</Icon></Link>) :
              null
            ), 
            subcontent: null,
          },
        ]}
      />

      {renderContent(asset, {onSave})}
    </WrapForm>
  )
}

const renderContent = (asset, {onSave}) => {
  if (asset.rough_content_type === "text") {
    return (<TextEditor asset={asset} onSave={onSave} />)
  } else if (asset.rough_content_type === "image") {
    return (<ImageViewer asset={asset} />)
  } else {
    return "このコンテンツは表示できません"
  }
}
